import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import styled from 'styled-components'

import { Card } from '@/pages/SpaceNotificatorPage/types'

const PreviewPanel = styled.div`
  display: block;
  width: 100%;
  text-align: center;
`
const Message = styled.div`
  color: ${({ theme }) => theme.notificator.wgColorDark};
  font-size: ${({ theme }) => theme.notificator.wgTextTiny};
  text-align: left;
  padding-left: 1rem;
`

const CardList = styled.ul`
  margin-top: 1rem;
`

const CardItem = styled.li`
  list-style-type: circle;
  color: ${({ theme }) => theme.notificator.wgColorDark};
  font-size: ${({ theme }) => theme.notificator.wgTextTiny};
  text-align: left;
`

const CardDetail = styled.ul`
  padding-inline-start: 1rem;
`

const AccordionItem = styled(Accordion)`
  border: none;
  box-shadow: none !important;
`

const AccordionItemSummary = styled(AccordionSummary)`
  padding: 0 !important;
  min-height: 0 !important;
  max-height: 1rem;
  display: inline-flex !important;
`

const ImageAccordion = styled(AccordionDetails)`
  padding: 0 !important;
`

const Image = styled.img`
  margin-top: 1rem;
  max-width: 291px;
  width: 100%;
`
type PreviewProps = {
  selectedCard?: Array<Card>
}
function Preview(props: PreviewProps) {
  const previewLocation = `/microapps/notificator/assets`

  return (
    <PreviewPanel>
      <Message>Your selection includes the following {props.selectedCard?.length} card(s):</Message>
      {props.selectedCard?.map(card => (
        <CardList key={card.key}>
          <CardItem>
            {card.name}
            <CardDetail>
              <CardItem>
                Will appear on the <strong>{card.location === 'todo' ? 'To Do' : 'To Know'}</strong> tab
              </CardItem>
              <CardItem>
                Currently available from the following data sources:{' '}
                <strong>
                  {card.existingIntegrations
                    ?.map(integration => integration.name)
                    .toString()
                    .replaceAll(new RegExp(',', 'g'), ', ')}
                </strong>
              </CardItem>
              <CardItem>
                <strong>
                  <i>Potentially</i>
                </strong>{' '}
                available from the following data sources:{' '}
                <strong>
                  {card.potentialIntegrations
                    ?.map(integration => integration.name)
                    .toString()
                    .replaceAll(new RegExp(',', 'g'), ', ')}
                </strong>
              </CardItem>
              <CardItem
                style={
                  props.selectedCard && props.selectedCard.length > 0 && card.previewFile
                    ? { display: 'list-item' }
                    : { display: 'none' }
                }
              >
                <AccordionItem TransitionProps={{ unmountOnExit: true }}>
                  <AccordionItemSummary expandIcon={<ExpandMore />}>Image preview</AccordionItemSummary>
                  <ImageAccordion>
                    <Image src={previewLocation + card.previewFile} />
                  </ImageAccordion>
                </AccordionItem>
              </CardItem>
            </CardDetail>
          </CardItem>
        </CardList>
      ))}
    </PreviewPanel>
  )
}

export default Preview
